/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePreviousStayRequest
 */
export interface UpdatePreviousStayRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePreviousStayRequest
     */
    has_previous_stay_in_facility: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdatePreviousStayRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the UpdatePreviousStayRequest interface.
 */
export function instanceOfUpdatePreviousStayRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "has_previous_stay_in_facility" in value;

    return isInstance;
}

export function UpdatePreviousStayRequestFromJSON(json: any): UpdatePreviousStayRequest {
    return UpdatePreviousStayRequestFromJSONTyped(json, false);
}

export function UpdatePreviousStayRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePreviousStayRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'has_previous_stay_in_facility': json['has_previous_stay_in_facility'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function UpdatePreviousStayRequestToJSON(value?: UpdatePreviousStayRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'has_previous_stay_in_facility': value.has_previous_stay_in_facility,
        'comment': value.comment,
    };
}

